module.exports = __webpack_public_path__ + "c54738d1dd6c041c1c7d7e0d9a1cfce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/saaspass-connect/manage/images/buttons/xxxhdpi/login_with-saaspass.png
// module id = 1748
// module chunks = 0